/**
 * Action-level permission IDs for the Estadística module.
 * Used to show/hide UI actions based on user permissions.
 * Source of truth: .amigrar/estadistica/permisos-estadistica.ts
 */
export const EstadisticaPermissions = {
  // ── Indicadores ──────────────────────────────────────────────────────────
  /** Ver el listado de indicadores (route-level). */
  INDICADORES_LISTAR: 1158,
  /** Agregar un nuevo indicador. */
  INDICADORES_INSERTAR: 1159,
  /** Editar información de un indicador. */
  INDICADORES_EDITAR: 1160,
  /** Eliminar un indicador. */
  INDICADORES_ELIMINAR: 1161,
  /** Obtener datos de un indicador. */
  INDICADORES_OBTENER_DATOS: 1150,

  // ── Colecciones (tablero collections) ──────────────────────────────────
  /** Listar colecciones de tableros. */
  COLECCION_LISTAR: 1151,
  /** Crear una nueva colección. */
  COLECCION_INSERTAR: 1152,
  /** Editar colección, ordenar tableros, establecer predeterminada. */
  COLECCION_MODIFICAR: 1153,
  /** Eliminar una colección. */
  COLECCION_ELIMINAR: 1154,

  // ── Tableros (dashboards dentro de colecciones) ─────────────────────────
  /** Crear un nuevo tablero. */
  TABLERO_INSERTAR: 1155,
  /** Editar tablero, marcar/desmarcar favorito. */
  TABLERO_MODIFICAR: 1156,
  /** Eliminar un tablero. */
  TABLERO_ELIMINAR: 1157,

  // ── Indicadores dentro de tableros ─────────────────────────────────────
  /** Agregar indicadores a un tablero. */
  INDICADOR_INSTANCIA_INSERTAR: 1163,
  /** Listar instancias de indicadores de un tablero. */
  INSTANCIA_LISTAR: 1162,
  /** Editar una instancia de indicador en un tablero. */
  INSTANCIA_EDITAR: 1164,
  /** Eliminar una instancia de indicador de un tablero. */
  INSTANCIA_ELIMINAR: 1165,
} as const;
